import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserMessageDialogComponent } from './user-message-dialog.component';
import { DialogModule } from '../dialog/dialog.module';
import { ButtonModule } from '../button/button.module';
import { RouteTrackingService } from '../../services/route-tracking.service';



@NgModule({
  declarations: [UserMessageDialogComponent],
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule
  ],
  exports: [UserMessageDialogComponent],
  providers: [RouteTrackingService]
})
export class UserMessageDialogModule { }
